export default {
  CREATE: `Créer une raison ou un type de congés`,
  DELETE_BUTTON: {
    TITLE: `Supprimer la raison/type`,
    SUMMARY: `Etes-vous certain de vouloir supprimer cette raison/type ?`,
    PRIMARY_ACTION: `Supprimer la raison/type`
  },
  LIST: {
    TITLE: `Liste des raisons et des types de congés`
  },
  TYPE: `Type`,
  COUNT_HOURS: `Compte comme des heures travaillées`,
  CANNOT_BE_SELF_ASSIGNED: `Ne peut pas être auto-assigné par des utilisateurs`,
  COUNT_IN_ABSENTEEISM_RATE: `Compte dans le taux d'absentéisme`,
  IGNORE_IN_CONTACT_LIST: `Ignorer dans les listes de contacts`,
  DESCRIPTION_FR: `Description française`,
  DESCRIPTION_EN: `Descrition anglaise`,
  IGNORE_RIGHT_REFUSE_WORK: `Ignorer le refus de travailler`,
  HAS_MIN_DELAY_AFTER_ABSENCE: `Indisponible pour une certaine durée après la requête`,
  MIN_DELAY_AFTER_ABSENCE: `Durée de l'indisponibiltié après la requête`,
  ALWAYS_SHOWN_IN_SCHEDULE: `Toujours affiché dans l'horaire`,
  LEAVEREASON: `Raison de l'absence`,
  LATEREASON: `Raison du retard`,
  EARLYOUTREASON: `Raison du départ hâtif`,
  VACATIONTYPE: `Type de congé`,
  CSV_EXPORT_NAME: `export_types_de_requetes_{{date}}`,
  form: {
    CREATE: {
      TITLE: `Création d'un type de congé ou d'une raison`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Modification d'un type de congé ou d'une raison`,
      SUMMARY: ``
    },

    NAMEFR: {
      LABEL: `Nom français`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Entrez le nom français`
    },
    NAMEEN: {
      LABEL: `Nom anglais`,
      DESCRIPTION: ``,
      PLACEHOLDER: `Entrez le nom anglais`
    },
    DESCRIPTIONFR: {
      LABEL: `Description française`,
      DESCRIPTION: `La description sera montrée aux utilisateurs lors de la création de ce type de requête.`,
      PLACEHOLDER: `Entrez une description en français`
    },
    DESCRIPTIONEN: {
      LABEL: `Description anglaise`,
      DESCRIPTION: `La description va être montrée aux utilisateurs lors de la création de ce type de requête.`,
      PLACEHOLDER: `Entrez une description en anglais`
    },
    EARNINGCODE: {
      LABEL: `Code de gain`,
      DESCRIPTION: `Le code de gain sert à pouvoir exporter des absences ou congés pour la paie et devra être défini dans votre système de paie.`,
      PLACEHOLDER: `Entrez le code de gain`
    },
    INDEX: {
      LABEL: `Indexe pour système d'appel`,
      DESCRIPTION: `Cet index sert dans le système d'appel à présenter à l'utilisateur les choix de raison d'absence ou de retard dans un ordre spécifique.`,
      PLACEHOLDER: `Entrer un chiffre supérieur ou égal à 1`
    },
    TYPE: {
      LABEL: `Type`,
      DESCRIPTION: `Détermine pour quel genre de requête ce type ou cette raison peuvent être utilisés.`
    },
    CODE: {
      LABEL: `Code d'importation`,
      DESCRIPTION: `Est utilisé lors de l'importation manuelle de données ou avec certaines intégrations.`,
      PLACEHOLDER: `Entrez un code d'importation`
    },
    COUNTHOURS: {
      LABEL: `Comptabiliser dans les heures travaillées`,
      DESCRIPTION: `Les requêtes utilisant ce type ou cette raison seront comptabilisées dans les heures travaillées.`
    },
    CANNOTBESELFASSIGNED: {
      LABEL: `Ne peut pas être auto-assigné`,
      DESCRIPTION: `Empêche les utilisateurs n'ayant pas les permissions nécessaires de s'auto-assigner ce type de requête.`
    },
    AUTOMATICALLYAPPROVED: {
      LABEL: `Approuver automatiquement`,
      DESCRIPTION: `Les requêtes de congés de ce type seront automatiquement approuvées.`
    },
    ALWAYSSHOWNINSCHEDULE: {
      LABEL: `Toujours afficher à l'horaire`,
      DESCRIPTION: `Ce type de requête sera toujours affichée à l'horaire, même si l'option dans la page d'horaire n'est pas active.`
    },
    COUNTINABSENTEEISMRATE: {
      LABEL: `Inclure dans le taux d'absentéisme`,
      DESCRIPTION: `Ces absences et ces retards seront comptabilisés dans le taux d'absentéisme.`
    },
    IGNOREINCONTACTLIST: {
      LABEL: `Ignorer dans les listes de contacts`,
      DESCRIPTION: `L'utilisateur faisant cette requête sera tout de même élgible pour un quart de travail.`
    },
    IGNORERIGHTTOREFUSEWORK: {
      LABEL: `Ignorer le refus de travailler`,
      DESCRIPTION: `Les requêtes utilisant cette raison n'afficheront pas l'avertissement disant que l'employé avait le droit de refuser le quart.`
    },
    HASMINDELAYAFTERABSENCE: {
      LABEL: `Indisponibilité suivant la requête`,
      DESCRIPTION: `Empêche l'utilisateur d'être éligible à un quart durant une période de temps suivant la requête.`
    },
    MINDELAYAFTERABSENCE: {
      LABEL: `Durée d'indisponibilité suivant l'absence (en minutes)`,
      DESCRIPTION: `Empêche l'utilisateur d'être éligible à un autre quart pour le nombre de minutes indiquées après la fin du quart.`,
      PLACEHOLDER: `Entrez le délai en minutes`
    },
    PARTIALDAYBYDEFAULT: {
      LABEL: `A une heure de début et fin`,
      DESCRIPTION: `Lors de la création de ce type de congé en assignation rapide, l'heure de début et fin choisie seront utilisées.`
    },
    DEFAULTSTARTTIME: {
      LABEL: `Heure de début par défaut`,
      DESCRIPTION: ``
    },
    DEFAULTENDTIME: {
      LABEL: `Heure de fin par défaut`,
      DESCRIPTION: ``
    },
    NAME_REQUIRED: `Le nom est obligatoire.`,
    TYPE_REQUIRED: `Le type est obligatoire.`
  }
}
